module.exports = __webpack_public_path__ + "static/budget-capital-cover-54aacbcd0b3f5a327eae99cad62c2c19.png";